"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var RangeValidator_1 = require("../../../core/model/data-dictionary/validators/RangeValidator");

var Range_1 = require("../../../core/model/math/Range");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");

var RangeConstraint_1 = require("./RangeConstraint");
/**
 * The minimum/maximum allowed price change that can be applied.
 *
 * @author RV
 */


var PriceChange =
/*#__PURE__*/
function (_RangeConstraint_1$Ra) {
  _inherits(PriceChange, _RangeConstraint_1$Ra);

  /**
   * @inheritDoc
   */
  function PriceChange(range) {
    var _this;

    _classCallCheck(this, PriceChange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChange).call(this, range));
    _this.range = range;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceChange, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.PriceChange;
    }
  }]);

  return PriceChange;
}(RangeConstraint_1.RangeConstraint);

exports.PriceChange = PriceChange;
PriceChange.MIN_VALUE = -90;
PriceChange.MAX_VALUE = 10000000; // tslint:disable-next-line:member-ordering

PriceChange.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RangeConstraint_1.RangeConstraint.name);
  return {
    range: builder.obj(Range_1.Range.name, Range_1.Range.schemaBigNumber, function (mat) {
      return new Range_1.Range(mat.minimum, mat.maximum);
    }, new RangeValidator_1.RangeValidator(PriceChange.MIN_VALUE, PriceChange.MAX_VALUE))
  };
}();